<section class="access-denied">
  <div class="access-denied__panel">
    <div class="access-denied__eyebrow">Restricted Screen</div>
    <h1 class="access-denied__title">{{ title }}</h1>
    <p class="access-denied__message" *ngIf="message">{{ message }}</p>
    <p class="access-denied__hint">{{ hint }}</p>
  </div>
</section>
